import { MessageCircle } from 'lucide-react';
import { businessInfo } from '../data/mock';

export const FloatingWhatsApp = () => {
  const whatsappUrl = `https://wa.me/${businessInfo.contact.whatsapp}?text=${encodeURIComponent(
    "Hi, I'd like to enquire about sound hire for my event."
  )}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-5 py-3 rounded-full bg-[#25D366] hover:bg-[#20bd5a] text-white font-semibold shadow-lg shadow-[#25D366]/30 hover:shadow-[#25D366]/50 transition-all duration-300 hover:scale-105 group"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm">Chat with us</span>
    </a>
  );
};
